
import CatalogueApi from '@/api/catalogueApi'
const api = new CatalogueApi()

export default {
  async setMeasurements(context, payload = '') {
    let measurements = context.getters.getMesurements
    if (!measurements?.length || measurements.length == 1 || payload) {
      return await api.getMeasurementsByName(payload)
        .then(response => {
          let items = response.data.mesurementUnit
          context.commit('setMesurements', items)
          return items
        })
    } else {
      return measurements
    }
  },

  async getResourcesGroup(context, payload ) {
    let resourceGroups = context.getters.getResourceGroups,
      group = resourceGroups?.find(cat => cat?.id == payload)
    if (!resourceGroups?.length || !group ) {
      return await api.getResourcesGroups(payload)
        .then(response => {
          if (!response.length) {
            return {}
          }
          let item = response[0],
            old = resourceGroups?.find(cat => cat?.id == item.id )
          item.children = []
          if ( !old ) {
            context.commit('addResourceGroup', item)
          }
          return old || item
        })
    } else {
      return group
    }
  },

}